import { ReactComponent as HefringLogo } from "assets/hefring-wordmark.svg";
import { Button } from "components/ui/button";
import { useStore } from "hooks/use-store";
import { Screens } from "navigation/routes";
import { Card, CardHeader } from "components/ui/card";

export default function ErrorScreen() {
  const setScreen = useStore((state) => state.setScreen);

  return (
    <section className="h-screen w-full flex flex-col items-center justify-center space-y-6">
      <HefringLogo width={250} height={100} />
      <Card>
        <CardHeader>
          <p className="text-center">An unexpected error has occurred</p>
        </CardHeader>
      </Card>
      <div>
        <Button onClick={() => setScreen(Screens.Dashboard)}>
          Return to Dashboard
        </Button>
      </div>
    </section>
  );
}
